import { lazy } from 'react';

export const YourNamePageLazy = lazy(() => import('./your-name'));
